export default __webpack_public_path__ + "static/media/Helm of Necrotic Dread.3a36fb8a.jpg";